import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { getSpacing } from "@faire/web--source/slate/spacing";
import * as React from "react";

interface DropdownChevronProps<T extends string> {
  value?: T;
  onClear?: () => void;
  disabled?: boolean;
}

export const DropdownChevron = <T extends string>({
  value,
  onClear,
  disabled,
}: DropdownChevronProps<T>) => {
  if (value && onClear) {
    return null;
  }
  return (
    <Chevron
      direction="down"
      width="8"
      height="8"
      color={disabled ? Core.icon.disabled : Core.icon.default}
      strokeWidth={2}
      margin={getSpacing(0, 0, 0, "1x")}
    />
  );
};
